import {inject, Injectable} from '@angular/core';
import {TranslocoService} from '@jsverse/transloco';
import {ApplicationLang, TranslationBase} from '@domain/common/common';

@Injectable({
  providedIn: 'root'
})
export class TranslationService {

  private readonly transloco = inject(TranslocoService);

  public getPreferred<T extends TranslationBase>(translations: T[]): T | null {
    const trs: {[lang: string]: T;} = translations.reduce(
      (obj, tr) => {
        obj[tr.lang] = tr;
        return obj;
      },
      {} as {[lang: string]: T;}) ?? {};
    const userLang = this.transloco.getActiveLang();

    if (trs[userLang]) {
      return trs[userLang];
    }

    for (const lang of this.transloco.getAvailableLangs() as string[]) {
      if (trs[lang]) {
        return trs[lang];
      }
    }

    for (const lang of Object.keys(ApplicationLang)) {
      if (trs[lang]) {
        return trs[lang];
      }
    }
    return translations?.[0] ?? null;
  }

}
